import React from "react";

export default function Tabs({ tabs, active, onChange }) {
  return (
    <div className="bill-tabs">
      {tabs.map((tab) => (
        <button
          type="button"
          key={tab}
          className={`bill-tab${active === tab ? " is-active" : ""}`}
          onClick={() => onChange(tab)}
        >
          {tab}
        </button>
      ))}
    </div>
  );
}
